import React from "react";
import { Form } from "antd";
import Input from "../../components/Input";
// import ReactInputMask from "react-input-mask";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import { useAuth } from "../../contexts/AuthContext";
// import { cnpjInputMask, cpfInputMask } from "../../utils";
import { AuthContainer } from "../../styles/LoginSignUp/authContainer";
import {
  validationFieldRequired,
  validationMaxLength20,
} from "../../utils/formValidations";

interface IData {
  username: string;
  pass: string;
}

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<IData>();
  const { handleSignIn, loading } = useAuth();

  const onFinish = async (data: IData) => {
    try {
      await handleSignIn({
        ...data,
        username: data.username.replace(/[_.-/-]/g, ""),
      });
    } catch (err: any) {
      return;
    }
  };

  const handleNavigate = () => {
    navigate("/p/cadastrar");
  };

  return (
    <AuthContainer className="beauty-scrollbar">
      <div className="auth-content">
        <div className="form-container">
          <h1 className="app-title" >Acesse sua conta</h1>
          <Form form={form} size="large" onFinish={onFinish}>
            <Form.Item name="username" rules={validationMaxLength20}>
              <Input placeholder="CPF ou CNPJ" maxLength={20} />
              {/* <ReactInputMask
                placeholder="CPF/CNPJ"
                className="ant-input ant-input-lg"
                mask={!isCnpj ? cpfInputMask : cnpjInputMask}
                onChange={(e: any) => {
                  if (
                    e.target.value.replace(/[_.-/-]/g, "").length ===
                    cpfCnpjValue.length
                  ) {
                    setIsCnpj(true);
                  } else if (
                    e.target.value.replace(/[_.-/-]/g, "").length < 12
                  ) {
                    setIsCnpj(false);
                  }
                  setCpfCnpjValue(e.target.value.replace(/[_.-/-]/g, ""));
                }}
              /> */}
            </Form.Item>

            <Form.Item name="pass" rules={validationFieldRequired}>
              <Input type="password" placeholder="Senha" />
            </Form.Item>

            <div className="buttons">
              <Button
                block
                size="large"
                type="primary"
                color="var(--veloprime-text-primary)"
                htmlType="submit"
                loading={loading}
              >
                Entrar
              </Button>
            </div>
            <div className="bottom-acessar">
              <Button
                type="text"
                size="small"
                className="btn-underlined"
                style={{ fontSize: "11px" , color: "var(--veloprime-deep-navy)", fontWeight: "700"}}
                onClick={() => navigate("/p/forgot-password")}
          
                
              >
                ESQUECI MINHA SENHA
              </Button>
            </div>
          </Form>

          {/* <div className="footer">
            Ainda não possui uma conta?
            <Button
              type="text"
              onClick={handleNavigate}
              className="btn-underlined"
              color="var(--veloprime-deep-navy)"
              style={{ fontSize: "11px", color: "var(--veloprime-deep-navy)", fontWeight: "700" }}
            >
              COMEÇAR
            </Button>
          </div> */}
        </div>
      </div>
    </AuthContainer>
  );
};
